// extracted by mini-css-extract-plugin
module.exports = {"container":"_owNqDZS","iconContainer":"_t0gyQwA","numberShadow":"_3M08ec7","doubleDigit":"_3Q98xe5","number":"_gQz8sER"};